import React from "react"
import { Transformation } from "cloudinary-react"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbSymbol from "../ui-kit/dfb_symbol"
import { concatStrings } from "../utilities"

const CCardTeaser = ({
  image,
  icon,
  topline,
  headline,
  description,
  anchor,
  href,
  add_class,
}) => (
  <a href={href} className={concatStrings("dfb-Card", add_class)}>
    {image && (
      <div className="dfb-Card-imageContainer">
        <DfbImage
          add_class="m-CardGrid-image"
          image={image}
          aspect_ratio="16:9"
          lazyload
        >
          <Transformation
            crop="fill"
            gravity="faces:center"
            width="800"
            height="450"
            quality="auto"
            fetchFormat="auto"
          />
        </DfbImage>
      </div>
    )}

    {icon && icon !== 'default' && (
      <div className="dfb-Card-icons">
        <div className="dfb-Card-icon">
          <DfbSymbol icon_type={icon} />
        </div>
      </div>
    )}

    <div className="dfb-Card-content">
      {topline && <div className="dfb-Card-topline">{topline}</div>}
      {headline && (
        <DfbHeadline
          headline={headline}
          noLevelClass="true"
          headline_level="h4"
          add_class="dfb-Card-headline"
        />
      )}
      {description && (
        <DfbParagraph text={description} add_class="dfb-Card-description" />
      )}
    </div>

    {anchor && (
      <div className="dfb-Card-footer">
        <DfbAnchor
          tagName="div"
          secondary={true}
          text={anchor}
          add_class="dfb-Card-anchor"
        />
      </div>
    )}
  </a>
)

export default CCardTeaser
